import * as React from "react";
import { Modal, Button, ModalProps } from "antd";
import i18n, { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";

interface ViewerModalProps {
  title: string | React.ReactNode;
  visible: boolean;
  onCancel: () => void;
  children: React.ReactNode;
  onFullScreen?: () => void;
  destroyOnHidden?: boolean;
  forceRender?: boolean;
  escToClose?: boolean;
  zIndex?: number;
  styles?: ModalProps["styles"];
  loading?: boolean;
}

export const ViewerModal = observer(
  ({ escToClose = true, forceRender = false, destroyOnHidden = true, zIndex = 1070, ...props }: ViewerModalProps) => {
    const modalWrapRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
      let focusTimeout: number | null = null;
      if (props.visible) {
        focusTimeout = window.setTimeout(() => {
          modalWrapRef.current?.focus();
        }, 0);
      }

      return () => window.clearTimeout(focusTimeout);
    }, [props.visible]);

    return (
      <Modal
        open={props.visible}
        onCancel={props.onCancel}
        destroyOnHidden={destroyOnHidden}
        forceRender={forceRender}
        className="viewer-modal"
        width={"100%"}
        style={{ maxWidth: `calc(100vw - 40px)` }}
        styles={props.styles}
        footer={null}
        zIndex={zIndex}
        keyboard={escToClose}
        loading={props.loading}
      >
        <div className="viewer-modal-wrap" ref={modalWrapRef} tabIndex={-1}>
          <div className="viewer-modal-title">
            {props.title}
            <div className="fl-r">
              {props.onFullScreen ? (
                <Button
                  onClick={props.onFullScreen}
                  type="link"
                  style={{ marginRight: 20, height: 25, padding: "0 15px" }}
                >
                  {i18n.t("Fullscreen", { ns: I18N_NS.PROJECT }) as string}
                </Button>
              ) : null}
            </div>
          </div>
          {props.children}
        </div>
      </Modal>
    );
  }
);
